




































































































































































































import { PopRoute, AddRoute, ReplaceRoute } from '../../types/store';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {Getter, Mutation, State} from "vuex-class";
import AdminPageInfo from './AdminPageInfo.vue';
import AdminCard from './AdminCard.vue';
import btn from './btn.vue';
import Label from './Label.vue';
import Axios from "axios";
import alzuhudLink from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo,
        AdminCard,
        btn,
        Label,
    }
})
export default class Booking extends Vue {
    private panelTitle: string;
    @State adminUser: string;
    @State routes: string[];
    @Mutation popRoute: PopRoute;
    @Mutation replaceRoute: ReplaceRoute;
    @State bookingId: number | null;
    @Getter token: string;
    @Mutation setBookingId: Function;
    hotel: any = {};
    flight: any = {};
    user: any = {};
    children: any[] = [];
    adults: any[] = [];
    title: string = '';
    startDate: string = '';
    endDate: string = '';
    price: string = '';
    country: string = '';
    numNights: number = 0;
    numAdults: number = 0;
    numChildren: number = 0;
    remarks: string = '';
    passengers: any[] =[];
    package: any = {};
    phone: string = '';
    email: string = '';
    name:string = '';

    async mounted(): Promise<void> {
        this.replaceRoute(['Bookings', 'Booking']);
        if(this.bookingId === null) {
            this.$router.push('bookings');
        } else {
            const response = await Axios.get(`http://${alzuhudLink}:8080/api/booking/all`, {
                params: {
                    token: this.token,
                    id: this.bookingId,
                }
            });

            console.log('hello', response)

            this.email = response.data.res.data[0].email;
            this.title = response.data.res.data[0].name;
            this.startDate = response.data.res.data[0].package_id.start_date;
            this.endDate = response.data.res.data[0].package_id.end_date;
            this.package = response.data.res.data[0].package_id;
            // @ts-ignore
            this.numNights = Math.ceil((new Date(this.endDate) - new Date(this.startDate))/ (1000 * 60 * 60 * 24));
            this.price = response.data.res.data[0].total_price;
            this.user = response.data.res.data[0].user_id;
            this.country = response.data.res.data[0].region;
            this.passengers = response.data.res.data[0].passengers;
            this.numAdults = response.data.res.data[0].num_adults;
            this.numChildren = response.data.res.data[0].num_childs;
            this.remarks = response.data.res.data[0].remarks;
            this.hotel = response.data.res.data[0].package_id.hotel_id;
            this.flight = response.data.res.data[0].package_id.airline_id;
            this.phone = response.data.res.data[0].phone;
            this.name = response.data.res.data[0].user_id.full_name;
        }
    }
    /**
     *
     */
    constructor() {
        super();
        this.panelTitle = 'Booking';
    }
    beforeDestroy(): void {
        this.popRoute();
        this.setBookingId(null);
    }

    checkTicket(e: MouseEvent): void {
        alert('hello');
    }

    order(i: number): string {
        if (i === 11 || i === 12 || i === 13) {
            return i+'th';
        }
        switch (i % 10) {
            case 1:
                return i+'st';
            case 2:
                return i+'nd';
            case 3:
                return i+'rd';
            default:
                return i+'th';
        }
    }

    split(str: string): string {
        let strData = parseFloat(str);
        let data = strData.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return data.split('.')[0];
    }
    weekday: string[] = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];

    getDay(dateStr: string) {
        const date = new Date(dateStr).getDay();
        return this.weekday[date];
    }
    getDate(dateStr: string): string {
        return new Date(dateStr).toLocaleDateString('en-US', { month: 'long', day: 'numeric'});
    }

    async downloadPdf() {
        const response = await Axios.get(`http://${alzuhudLink}:8080/api/pdf/booking/${this.bookingId}`, {
            params: {
                token: this.token,
                id: this.bookingId,
            }
        });
    }
}
